import React, { useState } from 'react'

import { useTranslation } from 'react-multi-lang'
import { uid } from '../../services/hoc/helpers'
import Modal from '../Modal/Modal'
import { createRoot, Root } from "react-dom/client";


interface StaticAlertProps {
    show: boolean,
    type: "warning" | "error" | "success" | "info",
    children?: any
}

export const StaticAlert = (props: StaticAlertProps) => {

    const [dasharray, setDasharray] = useState<number>(0)
    const id = uid("alert")

    return(
        <>
        {props.show ?
        <div className={"alert " + props.type }>
            <div className="alert-content">
                {props.children}
            </div>
        </div> : ""
        }
        </>
    )

}
interface ConfirmProps {
    message: string;
    onConfirm(): any;
    
}



interface ConfirmModalProps extends ConfirmProps {

    close:()=>void
}



const ConfirmModal = (props: ConfirmModalProps) => {
    
    const t = useTranslation()

    return(
        <Modal open={true} toggle={props.close} alwaysVisible={true}>
            <p style={{ margin: "0 0 30px" }}>{props.message}</p>
            <button className="button bg-gold color-white" style={{ minWidth: 80 }} onClick={() => {
                props.onConfirm()
                props.close()
            }}>{t("OK")}</button>
            <span className="margin-10" />
            <button className="button" onClick={props.close}>{t("Cancel")}</button>
        </Modal>
    )

}

export function Confirm(props: ConfirmProps) {
  const div = document.createElement("div");
  document.body.appendChild(div);

  const root: Root = createRoot(div);

  const close = () => {
    root.unmount();       // React 19-safe way to remove component
    div.remove();         // Remove DOM node
  };

  root.render(<ConfirmModal {...props} close={close} />);
}